<template>
  <div class="row">

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 card">

      <div class="card-header">
        <h3 class="title">{{ $t('farmer') }}</h3>
      </div>

      <div class="card-body">

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">{{ $t('post_title') }}</label>
                  <input class="form-control" v-model="pageTitle" type="text" :placeholder="$t('enter_title')" />
                </div>
              </div>
            </div>

            <div class="row">

                <div class="col-lg-12 col-md-12"
                  v-for="(element, index) in pageTemplate.elements"
                  :key="index"
                >
                  <p>
                    <fg-input v-if="element.field.type === 'categories'">
                      <el-select
                        size="large"
                        class="select-primary"
                        multiple
                        filterable
                        clearable
                        v-model="form[element.field.name]"
                        :placeholder="$t('select_categories')"
                      >
                        <el-option-group
                          v-for="group in categories"
                          :key="group.id"
                          :label="group.name">
                          <el-option
                            v-for="item in group.children"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </fg-input>
                  </p>

                  <text-field
                    :key="'input_text_'+index"
                    v-if="element.field.type === 'text'"
                    :unique-id="index"
                    :label="element.field.title"
                    v-model="form[element.field.name]"
                  ></text-field>

                  <!-- <rich-html
                    v-if="element.field.type === 'editor'"
                    v-model="form[element.field.name]"
                    :unique-id="index"
                  ></rich-html> -->

                  <vue-editor 
                    v-if="element.field.type === 'editor'"
                    v-model="form[element.field.name]"
                  />

                  <div v-if="element.field.type === 'file'">
                    <label :for="'file_'+index">{{ element.field.title }}</label>
                    <input
                      :id="'file_'+index"
                      :key="'file_key_'+index"
                      class="form-control"
                      type="file"
                      @change="setImage($event, element.field.name)"
                      placeholder
                    />
                  </div>

                </div>
                <div class="col-lg-12 col-md-12">
                  <div v-for="(grid, index) in grids.elements" :key="index">
                    <div v-if="grids.type === 'grid'" :unique-id="index" :key="'grid_container_'+index">
                      <fieldset class="border p-2">
                        <legend class="w-auto">Grid {{ index }}</legend>

                        <div class="form-group">
                          <label :for="'gridTitle_'+index">{{ $t('title') }}</label>
                          <input
                            :id="'gridTitle_'+index"
                            :key="'gridTitle_key_'+index"
                            class="form-control"
                            type="text"
                            v-model="inputs[index].title"
                            placeholder
                          />
                        </div>

                        <div class="form-group">
                          <label :for="'gridURL_'+index">{{ $t('URL') }}</label>
                          <input
                            :id="'gridURL_'+index"
                            :key="'gridURL_key_'+index"
                            class="form-control"
                            type="url"
                            v-model="inputs[index].url"
                            placeholder
                          />
                        </div>
                        <div class="form-group">
                          <label :for="'gridPageId_'+index">{{ $t('page_id') }}</label>
                          <input
                            :id="'gridPageId_'+index"
                            :key="'gridPageId_key_'+index"
                            class="form-control"
                            type="tel"
                            v-model="inputs[index].pageId"
                            placeholder
                          />
                        </div>

                        <div class="form-group">
                          <label :for="'gridSNumber_'+index">{{ $t('sort_number') }}</label>
                          <input
                            :id="'gridSortNumber_'+index"
                            :key="'gridSortNumber_key_'+index"
                            class="form-control"
                            type="text"
                            v-model="inputs[index].sortNumber"
                            placeholder
                          />
                        </div>

                        <label :for="'gridFile_'+index">{{ $t('image_icon') }}</label>
                        <input
                          type="file"
                          @change="setGridImage($event, index)"
                          :id="'gridFile_'+index"
                          :key="'gridFile_key_'+index"
                          class="form-control"
                        />
                      </fieldset>

                      <button
                        @click="addGrid(index)"
                        :key="'grid_add_btn_'+index"
                        :id="'grid_add_btn_'+index"
                        class="btn btn-info pull-right"
                        v-show="index == grids.elements.length-1"
                      >+</button>
                      <button
                        @click="removeGrid(index)"
                        :key="'grid_remove_btn_'+index"
                        :id="'grid_remove_btn_'+index"
                        class="btn btn-danger pull-right"
                        v-show="index || ( !index && grids.elements.length > 1)"
                      >X</button>
                    </div>
                  </div>

                </div>

            </div>

            <!-- <div class="row">

                  <fg-input label="Select NGO" class="col-md-12">
                    <el-select class="select-primary" v-model="selectedNGO" filterable clearable placeholder="Select NGO">
                        <el-option
                            class="select-primary"
                            v-for="ngo in NGOs"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.id"></el-option>
                    </el-select>
                  </fg-input>

                  <fg-input label="Select Country" class="col-md-12">
                    <el-select class="select-primary"
                    v-model="selectedCountry"
                    clearable
                    @change="onChange"
                    placeholder="Select Country">
                        <el-option
                            class="select-primary"
                            v-for="country in countries"
                            :key="country.id"
                            :label="country.name"
                            :value="country.id"></el-option>
                    </el-select>
                  </fg-input>

                  <fg-input label="Select Community" v-show="showCom" class="col-md-12">
                    <el-select class="select-primary" v-model="selectedCommunity" filterable clearable placeholder="Select Community">
                        <el-option
                            class="select-primary"
                            v-for="com in communities"
                            :key="com.id"
                            :label="com.name"
                            :value="com.id"></el-option>
                    </el-select>
                  </fg-input>
            </div> -->

      </div>

      <div class="card-footer">
        <button class="btn btn-info btn-block" @click="savePage()">{{ $t('save') }}</button>
      </div>

    </div>

  </div>
</template>
<script>
  import Vue from "vue";
  import {Option, Select, Table, TableColumn} from "element-ui";
  import PPagination from "src/components/UIComponents/Pagination.vue";
  import PSwitch from "src/components/UIComponents/Switch.vue";
  import Modal from "src/components/UIComponents/Modal.vue";
  import TextField from "@/components/UIComponents/TOL/TitleField.vue";
  import RichHtml from "@/components/UIComponents/TOL/RichHtml.vue";
  // import TextareaField from "@/components/UIComponents/TOL/Textarea.vue";
  import FileUpload from "@/components/UIComponents/TOL/FileUpload.vue";
  // import SelectBox from "@/components/UIComponents/TOL/SelectBox.vue";
  import Grid from "@/components/UIComponents/TOL/Grid.vue";

  import Resource from "@/util/Api/resource.js";
  import {fetchPageTemplate} from "@/util/Api/pageTemplate.js";
  import {savePage} from "@/util/Api/page.js";

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Select);
  Vue.use(Option);

  const CategoryResource = new Resource("category");
  const UserResource = new Resource("user");
  const FileResource = new Resource("files");

  export default {
  name: "PageComponent",
  components: {
    TextField,
    RichHtml,
    // TextareaField,
    FileUpload,
    // SelectBox,
    Grid,
    PPagination,
    Modal,
    PSwitch
  },

  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },

  data() {
    return {
      modals: {
        classic: false
      },
      loading: false,
      pagination: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [3, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["file_name"],
      tableColumns: [
        {
          prop: "file_name",
          label: this.$t("name")
        }
      ],
      tableData: [],
      files: [],

      pageTemplate: [],
      PageContent: {
        categories: []
      },
      grids: [],
      form: [],
      categories: [],
      users: [],
      countries:[],
      NGOs:[],
      communities:[],
      counter: 0,
      pageTitle: "",
      isItParent: false,
      showCom:false,
      inputs: [
        {
          title: "",
          url: "",
          pageId: null,
          file: null,
          sortNumber: null,
        }
      ],
      base64: null,
      formData: new FormData(),
      selectedNGO:'',
      selectedCountry:'',
      selectedCommunity:'',
    };
  },
  created() {
    this.getPageTemplate();
    this.getCategories();
    this.getUsers();
  },
  methods: {
    async setImage($event, fieldName) {
      let file = $event.target.files[0];
      this.form[fieldName] = await this.convertImage(file).catch(e => Error(e));
    },
    async setGridImage($event, index){
      let file = $event.target.files[0];
      this.inputs[index].file = await this.convertImage(file).catch(e => Error(e));
    },
    convertImage(file) {
      // let file = $event.target.files[0];
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    onCopy() {
      this.showAlertMessage(this.$t("url_copied_to_clipboard"), "success");
      this.modals.classic = false;
    },
    onCopyError() {
      this.showAlertMessage(this.$t("failed_to_copy_url"), "error");
    },
    async getFiles() {
      this.loading = true;
      await FileResource.list({})
        .then(response => {
          this.loading = false;
          this.tableData = response.data;
          this.files = response.data;
        })
        .catch(error => {
          this.loading = false;
          // this.showAlertMessage(error.message, "success");
        });
    },
    handleCreateModal() {
      this.modals.classic = true;
    },
    async getPageTemplate() {
      await fetchPageTemplate(this.$route.params.id)
        .then(response => {
          this.pageTemplate = response.data;
          this.pageTemplate.elements.forEach(element => {
            if (element.field.type === "grid") {
              this.grids = {
                type: "grid",
                elements: ["grid_0"]
              };
              return true;
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGrid(index) {
      this.counter++;
      this.inputs.push({ title: "", url: "" });
      this.grids.elements.push("grid_" + this.counter);
    },
    removeGrid(index) {
      this.inputs.splice(index, 1);
      this.grids.elements.splice(index, 1);
    },
    setGrid(value, gridObject, valueKey) {
      const gridKey = gridObject.name; // grid_1 or grid_2
      const gridValueKey = valueKey; // value_1 or value_2

      if (this.form[gridKey])
        this.form[gridKey] = Object.assign(this.form[gridKey], {
          [gridValueKey]: value
        });
      else {
        this.form[gridKey] = { [gridValueKey]: value };
      }
    },
    async savePage() {
      let obj = [];
      let counterIndex = 0;
      this.pageTemplate.elements.forEach(element => {
        obj[counterIndex] = {
          id: element.id,
          fieldNumber: element.fieldNumber,
          type: element.field.type,
          name: element.field.name,
          answer:
            element.field.type === "grid"
              ? this.inputs
              : this.form[element.field.name]
        };
        counterIndex++;
      });
      // getting the selected ngo
      // obj[counterIndex++] = {
      //     id: counterIndex,
      //     fieldNumber: counterIndex,
      //     type: 'select',
      //     name: 'NGO',
      //     answer: this.selectedNGO
      // };

      // getting the selected country
      // obj[counterIndex++] = {
      //     id: counterIndex,
      //     fieldNumber: counterIndex,
      //     type: 'select',
      //     name: 'Country',
      //     answer: this.selectedCountry
      // };

     // getting the delected community
      // obj[counterIndex++] = {
      //     id: counterIndex,
      //     fieldNumber: counterIndex,
      //     type: 'select',
      //     name: 'Community',
      //     answer: this.selectedCommunity
      // };

      let pageData = {};
      pageData.title = this.pageTitle;
      pageData.postTemplateID = this.$route.params.id;
      pageData.isItParent = this.isItParent;
      pageData.answers = JSON.stringify(obj);


      this.formData.append("title", pageData.title);
      this.formData.append("postTemplateID", pageData.postTemplateID);
      this.formData.append("isItParent", this.isItParent);
      this.formData.append("answers", pageData.answers);

      console.log(obj);
      console.log(pageData.answers);

      await savePage(this.formData)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
          // if (error.response.data.error) {
          //   this.$refs.formBuilderForm.setErrors(error.response.data.error.message);
          // }
        });
    },
    async getUsers() {
      await UserResource.list({})
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log("error occured");
        });
    },

    // Getting all category and filtering to get country and NGOs
    async getCategories() {
      await CategoryResource.list({})
        .then(response => {
          this.categories = response.data;

          this.categories.forEach((element) => {

                if(element.name === "NGOs"){
                   element.children.forEach((value) => {
                      this.NGOs.push(value);
                   });
                } else if(element.name === "Countries & Communities"){
                  element.children.forEach((value) => {
                      this.countries.push(value);
                   });
                }

          });

        })
        .catch(error => {
          console.log("error occured");
        });
    },

    // Get community for selected country
    onChange(value){
        this.showCom = true;
        this.communities = [];
        let obj = [];
        obj = this.countries.find(country => {
            return country.id === value;
        });
        obj.child.forEach((element) => {
          this.communities.push(element);
        });
    },

    setData(index) {},
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    }
  }
};
</script>
<style scoped>
.grid__unit {
  margin-bottom: 20px;
}
.el-select.select-primary.el-select--large {
  margin-top: 30px;
}
</style>
